module.exports = __webpack_public_path__ + "static/media/image (68).58dc78f1.jpg";